module.exports = __webpack_public_path__ + "media/images/bg/headers/sumo-1b183c05f649b9a65c727f2cbbd956c4.png";